module.exports = __webpack_public_path__ + "img/pt_ka.a4cbd034.png";